import { render, staticRenderFns } from "./PersonNameInput.vue?vue&type=template&id=4876c84d"
import script from "./PersonNameInput.vue?vue&type=script&lang=js"
export * from "./PersonNameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports